import React from 'react'

const PlusIcon = () => {
    return (
        <svg className='plus-icon' id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 258 258"><rect className="cls-1" y="112.5" width="258" height="33" rx="16.5" /><rect className="cls-1" x="171" y="203" width="258" height="33" rx="16.5" transform="translate(-90.5 429) rotate(-90)" /></svg>)
}

export default PlusIcon